module.exports = __webpack_public_path__ + "static/media/brand-1.21658f56.png";